import axios from 'axios';
import { WorksheetEditorConfig } from "@haohan/worksheet";
// import { WorksheetGenerateResponse } from '@haohan/papi-dto';

export const worksheetApi = {
	async generate(config: WorksheetEditorConfig) {
		const res = await axios.post<any>(
			'/api/worksheet/generate/', config
		);
		return res.data;
	},
	// async (config: WorksheetEditorConfig) {
	// 	const res = await axios.post<WorksheetGenerateResponse>(
	// 		'/api/worksheet/generate/', config
	// 	);
	// 	return res.data;
	// },
}